import {
  Form as AntdForm,
  Col,
  FormInstance,
  FormProps,
  Radio,
  Row,
} from "antd";
import { Gutter } from "antd/lib/grid/row";
import React from "react";
import styled from "styled-components";
import Error from "../../../assets/icons/Error.svg";
import { theme } from "../../../theme";
import Input from "../Input";
import InputNumber from "../InputNumber";
import RequiredStar from "../RequiredStar";
import Select from "../Select";
import TextArea from "../TextArea";
import { FormType } from "./shared/enums";
import { FormElement } from "./shared/interfaces";

export interface CustomFormProps extends FormProps {
  forms?: FormElement[];
  forminstances: FormInstance;
  gutter?: [Gutter, Gutter];
  isDetail?: boolean;
  initialValues?: any;
  isTitle?: boolean;
}

const FormItemBuilder: React.FC<CustomFormProps> = (props) => {
  const { gutter, forminstances, forms, isDetail, isTitle } = props;

  const renderFormElements = (form: FormElement) => {
    const {
      type = FormType.input,
      label,
      render,
      itemProps,
      span = 24,
      max = 100,
      renderDetail,
      key,
      options,
      title,
      maxLength,
      placeholder,
      labelTypo,
      isRequired = true,
    } = form;
    const getInputRender = (type: FormType) => {
      switch (type) {
        case FormType.textArea:
          return (
            <TextArea
              placeholder={placeholder}
              maxLength={1000}
              style={{ maxWidth: "480px" }}
            />
          );
        case FormType.input:
          return (
            <Input
              max={max}
              placeholder={placeholder}
              maxLength={maxLength}
              style={{ maxWidth: "480px" }}
            />
          );
        case FormType.inputNumber:
          return (
            <InputNumber
              max={max}
              placeholder={placeholder}
              maxLength={maxLength}
              style={{ maxWidth: "480px" }}
            />
          );
        case FormType.radio:
          return (
            <Radio.Group>
              {options?.map((val) => (
                <Radio value={val.value} key={val.value}>
                  {val.label}
                </Radio>
              ))}
            </Radio.Group>
          );
        case FormType.select:
          return (
            <Select
              style={{ maxWidth: "480px" }}
              options={options}
              placeholder={placeholder}
            />
          );
        case FormType.custom:
          if (render) return render(forminstances);
          return forminstances.getFieldValue(key);
        case FormType.question:
          return (
            <Row gutter={[0, 12]} style={{ width: "100%" }}>
              <Col
                span={24}
                style={{
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "14px",
                  lineHeight: "24px",
                }}
              >
                {label}
              </Col>
              <Col span={24}>
                {render
                  ? render(forminstances)
                  : forminstances.getFieldValue(key)}
              </Col>
            </Row>
          );
        default:
          return <Input />;
      }
    };
    if (isDetail)
      if (renderDetail) renderDetail(forminstances);
      else return forminstances.getFieldValue(key);

    return type === FormType.line ? (
      <StyledLine key={key} />
    ) : isTitle ? (
      <Col key={key} span={span}>
        <Row>
          <Col
            flex="0 0 140px"
            style={{
              fontStyle: "normal",
              fontWeight: 700,
              fontSize: "18px",
              lineHeight: "28px",
            }}
          >
            {title}
          </Col>
          <Col flex="1 1 0px">
            <AntdForm.Item
              extra="s"
              wrapperCol={{ span: 24, style: { height: "auto" } }}
              label={
                <>
                  {type === FormType.question
                    ? null
                    : itemProps?.label || label || ""}
                  {isRequired && <RequiredStar />}
                </>
              }
              name={itemProps?.name || key || ""}
              {...itemProps}
            >
              {getInputRender(type)}
            </AntdForm.Item>
          </Col>
        </Row>
      </Col>
    ) : (
      <Col key={key} span={span}>
        <StyledItem
          labelTypo={labelTypo}
          label={
            <>
              {type === FormType.question
                ? null
                : itemProps?.label || label || ""}
              {isRequired && <RequiredStar />}
            </>
          }
          name={itemProps?.name || key || ""}
          {...itemProps}
        >
          {getInputRender(type)}
        </StyledItem>
      </Col>
    );
  };

  return (
    <Row gutter={gutter || [0, 24]} style={{ display: "block" }}>
      {forms?.map((val) => renderFormElements(val))}
    </Row>
  );
};

const StyledLine = styled.div`
  width: 100%;
  border: 1px solid ${theme.colors.gray6};
  margin: 4px 0px;
`;
const StyledItem = styled(AntdForm.Item)<{ labelTypo?: string }>`
  .ant-form-item-explain-error {
    margin-top: 4px;
    display: flex;
    align-items: center;
    line-height: 24px;
    height: 24px;
  }
  .ant-form-item-explain-error::before {
    content: url(${Error});
    height: 20px;
  }
  .ant-form-item-no-colon {
    ${({ labelTypo }) => labelTypo || theme.typo.heading.b14};
  }
`;

export default FormItemBuilder;
